import React from 'react';
import styled from 'styled-components';
import { EmptyFacilities as EmptyFacilitiesIcon } from '@lt/components/icons-react/facilities';
import { useTranslation } from '@lt/localization';

const EmptyFacilities = ({ isMobile }): JSX.Element => {
  const { t } = useTranslation();
  return (
    <StyledContainer isMobile={isMobile}>
      <StyledEmptyFacilities />
      <StyledHeader isMobile={isMobile}>
        {t('hotel.facilities.empty.header')}
      </StyledHeader>
      <StyledText isMobile={isMobile}>
        {t('hotel.facilities.empty.text')}
      </StyledText>
    </StyledContainer>
  );
};

const StyledEmptyFacilities = styled(EmptyFacilitiesIcon)`
  width: 166px;
`;

const StyledContainer = styled.div<{ isMobile: boolean }>`
  padding: ${(props) => (props.isMobile ? '20px 25px 50px' : '50px 0')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
const StyledHeader = styled.div<{ isMobile: boolean }>`
  margin-bottom: 10px;
  font-size: ${(props) => (props.isMobile ? '18px' : '22px')};
  font-weight: bold;
  white-space: pre-line;
  color: ${(props) => props.theme.colors.blackBase};
`;
const StyledText = styled.div<{ isMobile: boolean }>`
  font-size: ${(props) => (props.isMobile ? '13px' : '14px')};
  text-align: center;
  color: ${(props) => props.theme.colors.blackLight};
`;
export default EmptyFacilities;
